import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createVNode as _createVNode } from "vue"

import * as BiTmplDetail_5_s from './components';

export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-6',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(BiTmplDetail_5_s, (item) => {
      return _createVNode(_resolveDynamicComponent(item), {
        key: item.name
      })
    }), 64))
  ]))
}
}

})